/* KIC v2 PDP - Mobile sticky ATC strip controller.
 *
 * Wave A: replaces the hero-IO logic in kic-v2-pdp.js (which kept the old
 * pill visible from the moment the hero left the viewport, with no scroll-up
 * hide). New behavior:
 *   1. Reveal when sentinel (rendered below the buy-box by kic-pdp-sticky-atc.liquid)
 *      scrolls out of view.
 *   2. Hide when scrolling up by more than HIDE_DELTA px in a single rAF tick
 *      (cleaner UX, gives the page back to the reader).
 *   3. Re-show when scrolling down again past the sentinel.
 *   4. Mobile only (max-width: 749px) - desktop is no-op.
 *   5. prefers-reduced-motion: skip transform animation by adding
 *      .is-reduced-motion which CSS keys off.
 */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) return;

  var strip = document.querySelector('[data-pdp-sticky-atc]');
  var sentinel = document.querySelector('[data-pdp-sticky-atc-sentinel]');
  if (!strip || !sentinel) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) strip.classList.add('is-reduced-motion');

  var pastSentinel = false;
  var lastY = window.scrollY || 0;
  var hideDelta = 6;
  var rafId = null;

  function setVisible(v) {
    strip.classList.toggle('is-visible', v);
    // F-18 (2026-05-10): swap aria-hidden -> inert. `inert` removes the
    // element from BOTH the a11y tree AND focus order; aria-hidden alone
    // left descendants tab-reachable (axe `aria-hidden-focus` P2 fail).
    // When v is true the strip is on-screen and interactive, so we drop
    // inert; when v is false the strip is off-screen, so we set inert.
    if (v) {
      strip.removeAttribute('inert');
    } else {
      strip.setAttribute('inert', '');
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Sentinel scrolled out of view (above viewport) means we are deep
        // enough to surface the strip.
        var aboveViewport = e.boundingClientRect.top < 0 && !e.isIntersecting;
        pastSentinel = aboveViewport;
        if (!pastSentinel) setVisible(false);
      });
    }, { threshold: 0 });
    io.observe(sentinel);
  } else {
    // Legacy fallback: 600px scroll heuristic.
    pastSentinel = (window.scrollY || 0) > 600;
  }

  window.addEventListener('scroll', function () {
    if (rafId != null) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      var y = window.scrollY || 0;
      var dy = y - lastY;
      lastY = y;
      if (!pastSentinel) { setVisible(false); return; }
      if (dy < -hideDelta) {
        // Scrolling up: hide cleanly.
        setVisible(false);
      } else if (dy > hideDelta) {
        setVisible(true);
      }
    });
  }, { passive: true });
})();
